  <tr class="full-sticky-group">
    <th class="col-first-level"></th>
    <th class="col-second-level"></th>
    <th class="col-third-level"></th>
    <th class="col-fourth-level">
      <div class="flex items-center justify-between">
        <span class="relative right-[5.5rem]">Budget</span>
        <div class="flex items-center">
          <app-button
            id="bm-table-bttn-toggle-groups"
            data-qa="bm-table-bttn-toggle-groups"
            class="expand-collapse-button left"
            [size]="'xxsmall'"
            [bordersSquaredShape]="'full'"
            [type]="'grey'"
            [iconName]="'arrows-collapse-vertical.svg'"
            (mouseenter)="showExpandTooltip('bm-table-bttn-toggle-groups', 'Expand/Collapse')"
            (mouseleave)="hideExpandTooltip()"
            (buttonClick)="toggleAllGroups()">
          </app-button>
          <app-button
            id="bm-table-bttn-toggle-quarters"
            data-qa="bm-table-bttn-toggle-quarters"
            class="expand-collapse-button right"
            [size]="'xxsmall'"
            [bordersSquaredShape]="'full'"
            [type]="'grey'"
            [iconName]="'arrows-collapse-horizontal.svg'"
            (mouseenter)="showExpandTooltip('bm-table-bttn-toggle-quarters', 'Quarters/Years')"
            (mouseleave)="hideExpandTooltip()"
            (buttonClick)="toggleAllQuarters()">
          </app-button>
        </div>
      </div>
    </th>
    <th class="blank-space col-fifth-level"></th>
    @for (p of budgetFormValue$$().modelHeaders; track $index; let last = $last) {
      @if (p.type === BmPeriodEnum.YEAR) {
        <th class="fix-w-5p5"
            [class.bg-black-4]="!(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(p.yearNumber))">
          <div class="flex items-center justify-between">
            <span>{{ p.headerText }}</span>
            <app-all-icons
              class="cursor-pointer"
              [iconNameAndStyling]="collapsedYears().get(p.yearNumber) ? 'arrow-right.svg' : 'arrow-left.svg'"
              [attr.data-qa]="'bm-collapse-' + p.yearNumber"
              (click)="toggleQuartersInSelectedYear(p.yearNumber)">
            </app-all-icons>
          </div>
        </th>
        <!-- thin spacer after each year, except last -->
        @if (!last) {
          <th class="fix-w-0p25 blank-space"
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(p.yearNumber)"></th>
        }
      }
      @if (p.type === BmPeriodEnum.QUARTER) {
        <th
          class="fix-w-5p5"
          [hidden]="p.isCollapsed">
          {{ p.headerText }}
        </th>
      }
    }

    <th [class.bg-black-4]="!budgetFormValue$$().isAllQuartersCollapsed"></th>
    <th class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></th>
    <th class="fix-w-5p5 right-sticky right-0">
      <div class="flex flex-col">
        <span>Total</span>
        <span class="caption-3 black-9">% of total</span>
      </div>
    </th>
  </tr>

  @if (expandTooltip$$().show) {
    <app-tooltip
      data-qa="bm-table-bttn-expand-tooltip"
      [coordinates]="expandTooltip$$().coordinates"
      [title]="expandTooltip$$().title"
      [isParentPositionRelative]="true">
    </app-tooltip>
  }
